import OtContractDashboard from '@/areas/projects/contracts/ot-contract-dashboard.vue';
import OtContractDetails from '@/areas/projects/contracts/ot-contract-details.vue';
import OtContractDocumentLayout from '@/areas/projects/contracts/ot-contract-document-layout.vue';
import OtContractDocuments from '@/areas/projects/contracts/ot-contract-documents-index.vue';
import OtContractUserDetails from '@/areas/projects/contracts/ot-contract-user-details.vue';
import OtContractUserLayout from '@/areas/projects/contracts/ot-contract-user-layout.vue';
import OtContractUsers from '@/areas/projects/contracts/ot-contract-users-index.vue';
import OtContractWorkflows from '@/areas/projects/contracts/ot-contract-workflows.vue';
import OtContractsLayout from '@/areas/projects/contracts/ot-contracts-layout.vue';
import OtCreateContractWizard from '@/areas/projects/contracts/ot-create-contract-wizard.vue';
import OtEditContractDetails from '@/areas/projects/contracts/ot-edit-contract-details.vue';
import OtEditContractUser from '@/areas/projects/contracts/ot-edit-contract-user.vue';
// import OtDocumentAssociations from '@/components/documents/document-associations/ot-document-associations-list.vue';
import OtDocumentDetails from '@/components/documents/document-details/ot-document-details.vue';
import { BreadcrumbsId } from '@/components/global/common-models';
import { RouteConfig } from 'vue-router';

export const ROUTE_CONTRACT_DASHBOARD = 'ContractDashboard';
export const ROUTE_CONTRACT_WORKFLOW_LIST = ROUTE_CONTRACT_DASHBOARD; // I always struggle to remember the dashboard is the list
/** Use this one if you just need to link to The Contract, but don't know where */
export const ROUTE_CONTRACT_DEFAULT = ROUTE_CONTRACT_DASHBOARD;
export const ROUTE_CONTRACT_ADD = 'AddContract';
export const ROUTE_CONTRACT_DETAILS = 'ContractDetails';
export const ROUTE_CONTRACT_DETAILS_EDIT = 'EditContractDetails';
export const ROUTE_CONTRACT_WORKFLOWTYPES = 'ContractWorkflowTypes';
export const ROUTE_CONTRACT_USERS = 'ContractUsers';
export const ROUTE_CONTRACT_DOCUMENTS = 'ContractDocuments';
export const ROUTE_CONTRACT_DOCUMENT = 'ContractDocument';
export const ROUTE_CONTRACT_DOCUMENT_ASSOCIATIONS = 'ContractDocumentAssociations';
export const ROUTE_CONTRACT_USER_DETAILS = 'ContractUserDetails';
export const ROUTE_CONTRACT_USER_EDIT = 'EditContractUser';

export const contractRoutes: Array<RouteConfig> = [
  {
    path: '/projects/:projectGid/contracts/add',
    name: ROUTE_CONTRACT_ADD,
    component: OtCreateContractWizard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/projects/:projectGid/contracts/:contractGid',
    component: OtContractsLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_CONTRACT_DASHBOARD,
        component: OtContractDashboard,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}`,
        },
      },
      {
        path: 'details',
        name: ROUTE_CONTRACT_DETAILS,
        component: OtContractDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Details`,
        },
      },
      {
        path: 'details/edit',
        name: ROUTE_CONTRACT_DETAILS_EDIT,
        component: OtEditContractDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Details/Edit`,
        },
      },
      {
        path: 'workflows',
        redirect: './',
      },
      {
        path: 'workflow-types',
        name: ROUTE_CONTRACT_WORKFLOWTYPES,
        component: OtContractWorkflows,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Workflow Types`,
        },
      },
      {
        path: 'users',
        name: ROUTE_CONTRACT_USERS,
        component: OtContractUsers,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Users`,
        },
      },
      {
        path: 'documents',
        name: ROUTE_CONTRACT_DOCUMENTS,
        component: OtContractDocuments,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Documents`,
        },
      },
    ],
  },
  {
    path: '/projects/:projectGid/contracts/:contractGid/documents/:documentGid',
    component: OtContractDocumentLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_CONTRACT_DOCUMENT,
        // Yes, this is not org specific, it's a shared document component
        component: OtDocumentDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Documents/${BreadcrumbsId.DocumentId}`,
        },
      },
      {
        path: 'associations',
        name: ROUTE_CONTRACT_DOCUMENT_ASSOCIATIONS,
        // normal list import doesn't work for contracts. Don't know why.
        //component: OtDocumentAssociationsList,
        // wrapper import does work, but I don't like it.
        //component: OtDocumentAssociationsListWrapper,
        // this weird import works. It's like the import that we have to do sometimes in the components declarations
        component: () => import('@/components/documents/document-associations/ot-document-associations-list.vue'), //OtDocumentAssociationsListWrapper,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Documents/${BreadcrumbsId.DocumentId}/associations`,
        },
      },
    ],
  },

  {
    path: '/projects/:projectGid/contracts/:contractGid/users/:userGid',
    component: OtContractUserLayout,
    meta: {
      requiresAuth: true,
      breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Users`,
    },

    children: [
      {
        path: '/',
        name: ROUTE_CONTRACT_USER_DETAILS,
        component: OtContractUserDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Users/${BreadcrumbsId.UserId}`,
        },
      },
    ],
  },
  {
    path: '/projects/:projectGid/contracts/:contractGid/users/:userGid/edit',
    name: ROUTE_CONTRACT_USER_EDIT,
    component: OtEditContractUser,
    meta: {
      breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts/${BreadcrumbsId.ContractId}/Users/${BreadcrumbsId.UserId}/Edit`,
    },
  },
];
